'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _events = require('./events');

var Events = _interopRequireWildcard(_events);

var _OauthToken = require('./OauthToken');

var _OauthToken2 = _interopRequireDefault(_OauthToken);

var _OauthConnection = require('./OauthConnection');

var _OauthConnection2 = _interopRequireDefault(_OauthConnection);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProtocolVersion = '2.0';

/**
 * @class
 */

var OauthFacade = function () {
  /**
   * @param {AppEventEmitter} eventDispatcher the outgoing events dispatcher
   * @param {function} setStorage
   */
  function OauthFacade(eventDispatcher, setStorage) {
    (0, _classCallCheck3.default)(this, OauthFacade);

    this.props = { eventDispatcher: eventDispatcher, setStorage: setStorage };
  }

  /**
   * Returns a map of settings required to register a client with `provider`. If `protocolVersion` is not specified in `options` then it defaults to `2.0`
   *
   * @method
   *
   * @param {String} provider the id of the provider
   * @param {{protocolVersion:String}} [options] a map of properties describing the oauth client. Only `protocolVersion` is supported for the moment
   *
   * @returns {Promise<OauthClientSettings, Error>}
   */


  (0, _createClass3.default)(OauthFacade, [{
    key: 'settings',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(provider, options) {
        var eventDispatcher, eventOptions;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                eventDispatcher = this.props.eventDispatcher;
                eventOptions = null;


                if ((typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object') {
                  eventOptions = (0, _extends3.default)({ protocolVersion: defaultProtocolVersion }, options, { provider: provider });
                } else {
                  eventOptions = { provider: provider, protocolVersion: defaultProtocolVersion };
                }

                if (!eventOptions) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return', eventDispatcher.emitAsync(Events.EVENT_SECURITY_SETTINGS_OAUTH, eventOptions));

              case 5:
                return _context.abrupt('return', _promise2.default.reject(new Error('invalid argument')));

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function settings(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return settings;
    }()
  }, {
    key: 'register',


    /**
     * Registers an oauth connection for a specific provider
     *
     * @method
     *
     * @param {String} provider the provider id
     * @param {OauthConnectionProperties} properties the connection properties
     * @return {Promise<OauthConnectionRegistrationResponse, Error>}
     */
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(provider, properties) {
        var connectionProps, connectionJS, storageName;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                connectionProps = (0, _extends3.default)({}, properties, { providerName: provider });
                connectionJS = _OauthConnection2.default.fromJS(connectionProps).toJS();
                storageName = 'oauth:' + provider;
                return _context2.abrupt('return', this.props.setStorage(storageName, connectionJS).then(function () {
                  return { name: storageName, value: connectionJS };
                }));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function register(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return register;
    }()
  }, {
    key: 'access',


    /**
     * Alias for OauthFacade.requestAccess
     *
     * @param {string} provider the provider id
     * @param {{protocolVersion:String}} [options] a map of properties describing the oauth client. Only `protocolVersion` is supported for the moment
     * @internal
     * @deprecated
     * @returns {Promise.<OauthToken, Error>}
     */
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(provider, options) {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.requestAccess(provider, options));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function access(_x5, _x6) {
        return _ref3.apply(this, arguments);
      }

      return access;
    }()

    /**
     * Requests an access token. If `protocolVersion` is not specified in `options` then it defaults to `2.0`
     * if `options` has an object property  named `query`, it will be used as additional query parameters appended to the
     * authorization url
     *
     * @method
     *
     * @param {string} provider the provider id
     * @param {{protocolVersion:String, query:object}} [options] a map of options controlling the access process.
     * @return {Promise<OauthToken, Error>}
     */

  }, {
    key: 'requestAccess',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(provider, options) {
        var eventOptions, eventDispatcher;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                eventOptions = null;

                if ((typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object') {
                  eventOptions = (0, _extends3.default)({}, options, { provider: provider });
                } else {
                  eventOptions = { provider: provider, protocolVersion: defaultProtocolVersion };
                }

                eventDispatcher = this.props.eventDispatcher;
                return _context4.abrupt('return', eventDispatcher.emitAsync(Events.EVENT_SECURITY_AUTHENTICATE_OAUTH, eventOptions).then(_OauthToken2.default.fromOauthProxyResponse).then(function (oauthToken) {
                  return oauthToken.toJS();
                }));

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function requestAccess(_x7, _x8) {
        return _ref4.apply(this, arguments);
      }

      return requestAccess;
    }()
  }, {
    key: 'refreshAccess',


    /**
     * Refresh an access token. If `protocolVersion` is not specified in `options` then it defaults to `2.0`
     * if `options` has an object property  named `query`, it will be used as additional query parameters appended to the
     * token url
     *
     * Note: the provider must explicitly support the refresh token flow
     *
     * @param {string} provider the provider id
     * @param {{protocolVersion:String, query:object}} [options] a map of options controlling the refresh process .
     * @returns {Promise<OauthToken, Error>}
     */
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(provider, options) {
        var eventOptions, eventDispatcher;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                eventOptions = null;

                if ((typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object') {
                  eventOptions = (0, _extends3.default)({}, options, { provider: provider });
                } else {
                  eventOptions = { provider: provider, protocolVersion: defaultProtocolVersion };
                }

                eventDispatcher = this.props.eventDispatcher;
                return _context5.abrupt('return', eventDispatcher.emitAsync(Events.EVENT_SECURITY_OAUTH_REFRESH, eventOptions).then(_OauthToken2.default.fromOauthProxyResponse).then(function (oauthToken) {
                  return oauthToken.toJS();
                }));

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function refreshAccess(_x9, _x10) {
        return _ref5.apply(this, arguments);
      }

      return refreshAccess;
    }()
  }]);
  return OauthFacade;
}();

exports.default = OauthFacade;

/**
 * Represents the result of registering an oauth connection
 *
 * @typedef {Object} OauthConnectionRegistrationResponse
 * @property {string} name the key to access the connection data from storage
 * @property {OauthConnection} value the oauth connection
 */

/**
 * Represents the information required to register client with an oauth provider
 *
 * @typedef {Object} OauthClientSettings
 * @property {string} urlRedirect
 */

/**
 * Represents the information required to setup an oauth connection with a provider
 *
 * @typedef {Object} OauthConnectionProperties
 * @property {String} urlAuthorize the url of the authorize endpoint
 * @property {String} urlAccessToken the url of the token endpoint
 * @property {String} urlRedirect the url the oauth provider will redirect the browser after the user grants access
 * @property {string} [urlResourceOwnerDetails]
 * @property {String} clientId the id of the client registered with the oauth provider
 * @property {string} [clientSecret] an optional client secret
 * @property {Array<string>} [scopes] an optional list of scopes
 */


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Security/OauthFacade.js
// module id = 316
// module chunks = 0